/**
 * 用户部门岗位
 */
import React from 'react';
import { UserCardAction } from './UserCardType';
export default function UserDeptTitle(props) {
    var partTimeTitleDeptInfo = props.partTimeTitleDeptInfo, status = props.status;
    return (React.createElement("div", null, partTimeTitleDeptInfo === null || partTimeTitleDeptInfo === void 0 ? void 0 : partTimeTitleDeptInfo.map(function (item, index) {
        return (React.createElement("div", { key: item.deptId + "-" + item.titleId },
            (item === null || item === void 0 ? void 0 : item.fullDeptName) && (React.createElement("div", { className: "usercard-item-content" },
                React.createElement("h5", { className: "usercard-item-title inner" }, "\u90E8\u95E8"),
                React.createElement("p", { className: "usercard-item-desc" }, item === null || item === void 0 ? void 0 : item.fullDeptName))),
            (item === null || item === void 0 ? void 0 : item.titleName) && (React.createElement("div", { className: "usercard-item-content" },
                React.createElement("h5", { className: "usercard-item-title inner" }, "\u804C\u52A1"),
                React.createElement("p", { className: "usercard-item-desc" }, item.titleName))),
            (item === null || item === void 0 ? void 0 : item.telephone) && status !== UserCardAction.Add && (React.createElement("div", { className: "usercard-item-content" },
                React.createElement("h5", { className: "usercard-item-title inner" }, "\u5EA7\u673A"),
                React.createElement("p", { className: "usercard-item-desc" }, item.telephone)))));
    })));
}
//# sourceMappingURL=UserDeptTitle.js.map